module.exports = __webpack_public_path__ + "a815976f321d951039923539f8dbc0cb.svg";